import { baseApi } from '@Services/api';
import { RequestTypes } from '@Constants/api';

const AutomationBuilderV0API = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        generateShortURL: builder.mutation({
            query: (payload) => ({
                url: '/v0/create_short_link',
                method: RequestTypes.POST,
                body: payload
            })
        }),
        rerunTrigger: builder.mutation({
            query: (payload) => ({
                url: '/v0/user/automation/rerun',
                method: RequestTypes.POST,
                body: payload
            })
        }),
        uploadImage: builder.mutation({
            query: (formData) => ({
                url: '/v0/upload/image',
                method: RequestTypes.POST,
                body: formData,
                formData: true
            })
        }),
    })
});

export const { useGenerateShortURLMutation, useRerunTriggerMutation, useUploadImageMutation } = AutomationBuilderV0API;
